export const API_HOST = {
  'v1': `${DP_API_HOST}/api/v1`
}
export const ISO_DATE_FORMAT = 'YYYY-MM-DD'